import { getPortfolioId, getSelectedModelId } from "modules/portfolio-root/selectors/portfolios"

export function getPreferenceKeyType(state, constraintsType) {
  if (constraintsType === "exposure") {
    const modelId = getSelectedModelId(state)
    return { type: "compareFrontierExposures", key: `${getPortfolioId(state)}:${modelId}` }
  }
  return { type: "compareFrontierConstraints", key: getPortfolioId(state) }
}

export function resetPreferencesItems(state) {
  const portfolioId = getPortfolioId(state)
  const modelId = getSelectedModelId(state)
  return [
    { type: "compareFrontierExposures", key: `${portfolioId}:${modelId}` },
    { type: "compareFrontierForecast", key: `${portfolioId}` },
    { type: "compareFrontierConstraints", key: `${portfolioId}` },
  ]
}
